var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.getCurrentLocation}},[_c('div',{staticClass:"tooltip"},[_c('v-icon',[_vm._v("mdi-map-marker-outline")]),_c('span',{staticClass:"tooltiptext"},[_vm._v(_vm._s(_vm.$t('share location')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }